import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { TextField, Autocomplete } from "@mui/material";
import { OrangeTextButton } from "../../common/OrangeTextButton";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { handleAddNewCalendar } from "./CalendarsUtils/handleAddNewCalendar";
import { NavigateFunction } from "react-router-dom";
import { handleEditCalendar } from "./CalendarsUtils/handleEditCalendar";
import { useCalendarGroupAutocomplete } from "./CalendarsUtils/useCalendarGroupAutocomplete";

export const EditCalendarDialog = ({
  selectedRow,
  editCalendarDialogOpen,
  setEditCalendarDialogOpen,
  calendarData,
  setCalendarData,
  setCalendarAlerts,
  rowIndex,
  setSelectedRow,
  setEditingCalendar,
  navigate,
}: {
  selectedRow: any;
  editCalendarDialogOpen: boolean;
  setEditCalendarDialogOpen: Dispatcher<boolean>;
  calendarData: any;
  setCalendarData: any;
  setCalendarAlerts: any;
  rowIndex: any;
  setSelectedRow: any;
  setEditingCalendar: any;
  navigate: NavigateFunction;
}) => {
  const parentAccounts = JSON.parse(
    localStorage?.parentAccounts || "[]"
  );

  const parentNames = new Map();
  parentAccounts.forEach((object: any) => {
    parentNames.set(object.id, object.name);
  });

  const [changesMade, setChangesMade] = React.useState(false);

  const [updatedCalendarInfo, setUpdatedCalendarInfo] = React.useState<any>({
    group: selectedRow.group.id,
    name: selectedRow.name,
  });

  const {
    filteredGroupOptions,
    groupFilterInput,
    onGroupInputChange,
    clearGroupFilterInput,
    filterOptionsIdentity,
  } = useCalendarGroupAutocomplete(parentAccounts, updatedCalendarInfo.group);

  return (
    <Dialog open={editCalendarDialogOpen}>
      <DialogTitle id="add-calendar">Edit Calendar</DialogTitle>
      <DialogContent sx={{ width: 450, height: 375 }}>
        <TextField
          variant="standard"
          label="Calendar Name"
          value={updatedCalendarInfo.name}
          onChange={(event) => {
            setChangesMade(true);
            setUpdatedCalendarInfo((previousState: any) => {
              return { ...previousState, name: event.target.value };
            });
          }}
          sx={{ width: "350px" }}
          helperText=""
          type="string"
        />
        <br></br>
        <br></br>
        <Autocomplete
          disablePortal
          options={filteredGroupOptions}
          inputValue={groupFilterInput}
          onInputChange={onGroupInputChange}
          filterOptions={filterOptionsIdentity}
          getOptionLabel={(option) => option.name || ""}
          isOptionEqualToValue={(option, value) =>
            value != null && String(option.id) === String(value.id)
          }
          value={
            updatedCalendarInfo.group !== "" &&
            updatedCalendarInfo.group != null
              ? {
                  id: Number(updatedCalendarInfo.group),
                  name: parentNames.get(Number(updatedCalendarInfo.group)),
                  index: parentAccounts.findIndex(
                    (obj: any) => obj.id === Number(updatedCalendarInfo.group)
                  ),
                }
              : null
          }
          onChange={(event: any, value: any) => {
            setChangesMade(true);
            if (value == null) {
              clearGroupFilterInput();
            }
            setUpdatedCalendarInfo((previousState: any) => ({
              ...previousState,
              group: value?.id ?? "",
            }));
          }}
          sx={{ width: 350 }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="standard"
              label="Group"
              autoComplete="off"
              id="group_name"
              name="group_name"
            />
          )}
        />
      </DialogContent>
      <DialogActions>
        <OrangeTextButton
          onClick={() => {
            setEditCalendarDialogOpen(false);
          }}
          text="Cancel"
          disabled={false}
        />
        <OrangeTextButton
          onClick={() => {
            setEditCalendarDialogOpen(false);
            setEditingCalendar(true);
            handleEditCalendar(
              rowIndex,
              selectedRow.id,
              selectedRow.group.name,
              updatedCalendarInfo,
              calendarData,
              setCalendarData,
              setCalendarAlerts,
              setSelectedRow,
              setEditingCalendar,
              navigate
            );
          }}
          text="Submit"
          disabled={!changesMade}
        />
      </DialogActions>
    </Dialog>
  );
};
